import { formatNumberMix } from '@/utils'

export default {
  data() { },
  methods: {
    setTableConfig(data = []) {
      return {
        type: 'table',
        title: this.$t('sale-analysis::station::table_name'),
        ref: 'table',
        height: '325px',
        cancelShadow: true,
        tableData: data
      }
    },
    setSaleTrendData(data = []) {
      return {
        type: 'line',
        title: this.$t('sale-analysis::trend::charts_title'),
        ref: 'lineChart',
        height: '325px',
        chart: {
          legend: {
            show: true,
            data: [this.$t('sale-analysis::trend::charts_bar'), this.$t('sale-analysis::trend::charts_line')]
          },
          xAxis: {
            data: data.map(item => item.date)
          },
          yAxis: [
            {
              type: 'value',
              name: this.$t('sale-analysis::trend::charts_bar'),
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              min: 0,

            },
            {
              type: 'value',
              min: 0,
              name: this.$t('sale-analysis::trend::charts_line'),
            }
          ],
          series: [
            {
              name: this.$t('sale-analysis::trend::charts_bar'),
              type: 'bar',
              data: data.map(item => Number(item.saleAmount))
            },
            {
              name: this.$t('sale-analysis::trend::charts_line'),
              yAxisIndex: 1,
              type: 'line',
              data: data.map(item => Number(item.customerPricePer))
            }
          ]
        }
      }
    },
    setCountList(data) {
      let list = new Array(4).fill(null)
      list[0] = {
        title: `${this.$t('sale-analysis::sales_title')}(USD)`,
        // current: data.currency,
        tab: 1,
        count: data && this.$dataCheck(formatNumberMix(data.saleAmount, 2, ',')),
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastSaleAmount, 2, ',')),
        statisticsDays: data && this.$dataCheck(data.statisticsDays),
        down: data && data.saleAmountRatio ? data.saleAmountRatio < 0 : false,
        rate: data && this.$dataCheck(formatNumberMix(data.saleAmountRatio, 2, '', '')),
        tooltip: this.$t('sale-analysis::sales_tooltip')
      }
      list[1] = {
        title: `${this.$t('sale-analysis::orderPrice_title')}(USD)`,
        tab: 1,
        // current: data.currency,
        count: data && this.$dataCheck(formatNumberMix(data.customerPricePer, 2, ',')),
        down: data && data.customerPricePerRatio ? data.customerPricePerRatio < 0 : false,
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastCustomerPricePer, 2, ',')),
        statisticsDays: data && this.$dataCheck(data.statisticsDays),
        rate: data && this.$dataCheck(formatNumberMix(data.customerPricePerRatio, 2, '', '')),
        tooltip: this.$t('sale-analysis::orderPrice_tooltip')
      }
      list[2] = {
        title: this.$t('sale-analysis::changeRatio_title'),
        tab: 1,
        count: data && this.$dataCheck(formatNumberMix(data.transRate, 2, ',', '%')),
        down: data && data.transRateRatio ? data.transRateRatio < 0 : false,
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastTransRate, 2, ',', '%')),
        statisticsDays: data && this.$dataCheck(data.statisticsDays),
        rate: data && this.$dataCheck(formatNumberMix(data.transRateRatio, 2, '', '%')),
        tooltip: this.$t('sale-analysis::changeRatio_tooltip')
      }
      list[3] = {
        title: this.$t('sale-analysis::visitorNum_title'),
        tab: 1,
        count: data && this.$dataCheck(formatNumberMix(data.clientCnt, 0, ',')),
        down: data && data.clientCntRatio ? data.clientCntRatio < 0 : false,
        lastCount: data && this.$dataCheck(formatNumberMix(data.lastClientCnt, 2, ',')),
        statisticsDays: data && this.$dataCheck(data.statisticsDays),
        rate: data && this.$dataCheck(formatNumberMix(data.clientCntRatio, 0, '', '')),
        tooltip: this.$t('sale-analysis::visitorNum_tooltip')
      }
      return list
    },
    setSalesTableConfig(data = []) {
      return {
        title: this.$t('board::title_商品销售概况'),
        ref: 'salesTable',
        height: '325px',
        cancelShadow: true,
        tableData: data
      }
    },
    setSalesPieEchartConfig(data = []) {
      return {
        title: this.$t('board::title_地区销售金额占比'),
        type: 'ring',
        ref: 'salesPieEchart',
        height: '325px',
        tip: '',
        chart: {
          tooltip: {
            trigger: 'item',
            formatter: (params, ticket, callback) => {
              return `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params.color}"></span><span>${params.name}  </span><span style="font-weight:900;">${params.value}</span><br/>
                            <span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;"></span><span>${params.name}  </span><span style="font-weight:900;">${params.data.rate}%</span>`
            }
          },
          series: [
            {
              type: 'pie',
              radius: ['50%', '70%'],
              label: {
                show: false,
                position: 'left'
              },
              itemStyle: {
                normal: {
                  labelLine: {
                    show: false
                  }
                }
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: '12'
                }
              },
              labelLine: {
                show: false
              },
              data: data.map(item => {
                return {
                  value: item.turnover,
                  rate: item.turnoverPer,
                  name: item.country
                }
              })
            }
          ]
        }
      }
    },
    setConsumeTableConfig(data = []) {
      return {
        title: this.$t('board::title_顾客消费概况'),
        ref: 'consumeTable',
        height: '325px',
        cancelShadow: true,
        tableData: data
      }
    },
    setBuyBarEchartConfig(data = []) {
      return {
        title: this.$t('board::title_复购率月度趋势'),
        type: 'line',
        ref: 'lineChart',
        height: '325px',
        chart: {
          legend: {
            show: true,
            data: [this.$t('board::echarts_下单顾客数'), this.$t('board::echarts_复购率')]
          },
          tooltip: {
            formatter: (params, ticket, callback) => {
              let str = ''
              params.forEach(item => {
                str += `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${item.color}"></span>`
                str += `<span>${item.seriesName} </span><span style="font-weight:900;">${item.value}${item.seriesType === 'line' ? '%' : ''}</span> <br/> `
              })
              return str
            }
          },
          xAxis: {
            data: data.map(item => item.date)
          },
          yAxis: [
            {
              type: 'value',
              name: this.$t('board::echarts_下单顾客数'),
              splitLine: {
                lineStyle: {
                  type: 'dashed'
                }
              },
              min: 0,

            },
            {
              type: 'value',
              min: 0,
              name: this.$t('board::echarts_复购率'),
              axisLabel: {
                formatter: '{value}%'
              }
            }
          ],
          series: [
            {
              name: this.$t('board::echarts_下单顾客数'),
              type: 'bar',
              data: data.map(item => Number(item.orderCustomerNum))
            },
            {
              name: this.$t('board::echarts_复购率'),
              type: 'line',
              yAxisIndex: 1,
              data: data.map(item => Number(item.repurchaseRate))
            }
          ]
        }
      }
    },
  }
}
